export const Invoicedata = [
    { id: 1, invoiceNumber: 'Invoice002300', amount: "$25", product: '921021' },
    { id: 2, invoiceNumber: 'Invoice002299', amount: "$16", product: '435423', isSelected: true },
    { id: 3, invoiceNumber: 'Invoice002300', amount: "$32", product: '921021' },
    { id: 4, invoiceNumber: 'Invoice002300', amount: "$18", product: '921021' },
    { id: 5, invoiceNumber: 'Invoice002300', amount: "$25", product: '921021' },
    { id: 6, invoiceNumber: 'Invoice002299', amount: "$16", product: '435423' },
    { id: 7, invoiceNumber: 'Invoice002300', amount: "$32", product: '921021' },
    { id: 8, invoiceNumber: 'Invoice002300', amount: "$18", product: '921021' },
    { id: 9, invoiceNumber: 'Invoice002300', amount: "$25", product: '921021' },
    { id: 10, invoiceNumber: 'Invoice002299', amount: "$16", product: '435423' },
    { id: 11, invoiceNumber: 'Invoice002300', amount: "$32", product: '921021' },
    { id: 12, invoiceNumber: 'Invoice002300', amount: "$18", product: '921021' }
]